// Initials for the account button and the school crest fallback (FR-006, FR-026; data-model §1, §5).

const words = (text: string): string[] =>
  text.trim().split(/\s+/).filter(Boolean);
const first = (word: string): string =>
  (Array.from(word)[0] ?? "").toUpperCase();

/** First letters of the first and last words, upper case; one letter for one word; `?` when empty. */
export function initialsOf(displayName: string): string {
  const w = words(displayName);
  if (w.length === 0) return "?";
  if (w.length === 1) return first(w[0] ?? "");
  return first(w[0] ?? "") + first(w[w.length - 1] ?? "");
}

const SKIPPED = new Set(["the", "of", "and"]);

/** First letters of up to the first two words that are not "the", "of", "and", upper case. */
export function schoolInitials(name: string): string {
  const letters = words(name)
    .filter((w) => !SKIPPED.has(w.toLowerCase()))
    .slice(0, 2)
    .map(first)
    .join("");
  return letters || "?";
}
